(function ($, Global) {
	var ArticleModel = function() {
	    this.requested = false;
	};

    ArticleModel.prototype.readLater = function (data, callback) {
        var self = this;

        if (!this.requested) {
            this.requested = true;

            $.ajaxPostWithTimeout('/ajax/articles/readlater', data,50000)
                .done(function (result) {                   
                    Global.ajaxCallback({
                        results: result,
                        success: callback
                    });
                })
                .always(function() {
                    self.requested = false;
                });
        }	
	};

    ArticleModel.prototype.display = function (data, callback) {
        var self = this; 

        if (!this.requested) {
            this.requested = true;

            $.ajaxPost('/ajax/articles/display', data)
                .done(function (result) {
                    Global.ajaxCallback({
                        results: result,
                        success: callback
                    });
                })
                .always(function() {
                    self.requested = false;
                });
        }		
	};

	Global.ArticleModel = ArticleModel;
}(jQuery, window));